export const notRequireAuthPaths = [
    "/privacy",
    "/terms",
    "/subscription-terms",
    "/auth/signin",
    "/auth/signup",
    "/auth/confirm-email",
    "/auth/create-password",
    "/auth/forgot-pass",
    "/auth/loader",
    "/auth/set-email",
    "/auth/set-password",
    "/auth/verify-code",
    "/payment",
    "/onboarding",
    "/app-onboarding",
    "/certificate",
    "terms",
    "/experiment",
    "/creator",
    "/luck",
    "/reviews",
    "/refund-policy",
    "/pricing",
    "/research",
    "/contact",
    "/about-us",
    // Admin editor's iframe preview: no user session, must never bounce to
    // /auth/signin (neither via the auth-guard samples nor the HTTP 401 handler).
    "/upsell-preview",
];
